import { createSelector } from 'reselect'
import { TransmisisonMapping } from './formSections/util'

export const selectCountryList010=state=>state.DropDownValues.CountryList010
export const selectCountryList008=state=>state.DropDownValues.CountryList008
export const selectCountryList208=state=>state.DropDownValues.CountryList208
export const selectCountryList199=state=>state.DropDownValues.CountryList199
export const selectProcedure =state=>state.Shipment?.exitInfo?.procedure
export const selectTransmissionTypeVal=state=>state.Shipment?.exitInfo?.transmissionType
export const selectMrnNo=state=>state.Shipment?.exitInfo?.mrn



export const selectMot=(state)=>state.Shipment.transportation.borderTransitMode?.mot

export const selectAgentRep = (state) => state.Actor?.agent?.representation;

export const isContactVisibleSelector = createSelector(
    [selectAgentRep],
    (selectedRep) => {
      return !selectedRep || selectedRep=="2"
    }
  );

  export const selectActorEoriNo=createSelector(
    [
      state=>state.Actor,
    (_,actorType)=>actorType
    ],
    (actors,actorType)=>(actorType ? actors[actorType.toLowerCase()].eoriNo || "" : "")
  )
  

  export const selectDecType=createSelector(
  [
    (state)=>state.DropDownValues.impDeclarationTypes,
    (state)=>state.DropDownValues.expDeclarationTypes,
    (_,isImportShipment)=>isImportShipment
  ],
  (impDeclarationTypes,expDeclarationTypes,isImportShipment)=>  isImportShipment ? impDeclarationTypes :expDeclarationTypes
  )
   
  
  
  const createParameterSelector=(selector)=> {
    return (_, params) => selector(params);
  }
  
  const getisImportShipmentParam = createParameterSelector(params => params.isImportShipment);
  const getdeclarationStatusParam = createParameterSelector(params => params.decStatus);
  const getisDMSParam = createParameterSelector(params => params.isDMS);
  
  const selectTransmisionType=createSelector(
    [
      (state)=>state.DropDownValues.expTransmissionTypes,
      (state)=>state.DropDownValues.impTransmissionTypes,
      getisImportShipmentParam
    ],
    (expTransmissionTypes,impTransmissionTypes,isImportShipment)=>isImportShipment ? impTransmissionTypes:expTransmissionTypes
  )

  export const selectDeclarationType=state=>state.Shipment?.exitInfo?.declarationType

  export const selectTransmisisonTypeUsingDeclStatus=createSelector(
   [
    selectTransmisionType,
    getisImportShipmentParam,
    getdeclarationStatusParam,
    selectDeclarationType,
    getisDMSParam
   ],
   (transmissionList,isImportShipment,decStatus,declarationEntryType,isDMS)=>{

    if(isImportShipment)
         return transmissionList

        
    return transmissionList.filter((item)=>{
       const mapping=TransmisisonMapping(isDMS,isImportShipment)
       const {decStatus:decStatusList,decType}=mapping[item.value]
       return decStatusList.includes(decStatus) && (decType ?  decType.includes(declarationEntryType): true)
    })
   }
  )